import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import Api, {Utils} from '../Api';
import NoProducts from '../components/NoProducts';
import Processing from '../components/Processing';
import LightBox from '../components/LightBox';
import CategoryBar from '../components/CategoryBar';
import BreadCrumb from '../components/BreadCrumb';
import Footer from '../views/Home/Footer';
import {MarketplaceCarousel} from '../components/Marketplace';
import MakerRecommendationsList from  '../components/MakerRecommendations';

import RetailerProduct from './ProductModal';
import RecommendationGrid from './RecommendationGrid';

import historyList from '../lib/history';

import {
  CATEGORY_FILTERS,
  SHOP_ALL_CATEGORY,
  JUST_FOR_YOU_CATEGORY,
  RECENT_ORDERS_CATEGORY
} from '../consts';
import {capitalizeEveryWord} from '../lib/StringUtils';
import {generateUUID} from '../lib/UUID';

import './Retailer.less';

const RECOMMENDATION_TYPES = {
  SEARCH: 'search',
  CATEGORY: 'category'
};
const OFFSET_TO_LOAD = 300;

const calculateButtonText = selections => {
  let totalCases = 0;
  selections.forEach(selection => {
    totalCases += selection.batches;
  });

  if (totalCases >= 2) return 'Add Cases to Bag';

  return 'Add Case to Bag';
};

let lastRetailerScrollPosition = 0;

class RecentOrdersCarousel extends Component {
  static propTypes = {
    recentOrders: PropTypes.object,
    selectBrand: PropTypes.func,
    selectProduct: PropTypes.func,
    selectCollection: PropTypes.func,
    generateProductUrl: PropTypes.func,
    retailerToken: PropTypes.string.isRequired
  };

  render() {
    const recentOrders = this.props.recentOrders;
    if (!recentOrders
      || !recentOrders.brands
      || !recentOrders.display_order
      || recentOrders.display_order.length <= 0) return null;

    return <div className="reorder-carousel-component">
      {this.props.children}
      <div className="reorder-carousel-container">
        <MarketplaceCarousel brands={recentOrders.brands}
                             products={recentOrders.products || {}}
                             displayOrder={recentOrders.display_order}
                             generateProductUrl={this.props.generateProductUrl}
                             retailerToken={this.props.retailerToken}
                             minimize={false}
                             selectBrand={this.props.selectBrand}
                             selectProduct={this.props.selectProduct}
                             selectCollection={this.props.selectCollection}/>
      </div>
    </div>;
  }
}

export default class Retailer extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);
    Utils.bindThis(
      this,
      [
        'selectProduct',
        'generateProductUrl',
        'selectCollection',
        'generateCollectionUrl',
        'getMargin',
        'setCategory',
        'categoryBar',
        'closeProductModal',
        'productModal',
        'redirectToRetailerPage',
        'addToCart',
        'getRecommendedProduct',
        'getCartSelection',
        'onScroll',
        'onUserChanged',
        'onRecentOrdersChanged',
        'handleLoadError'
      ]
    );

    let productToken = props.params.productId ? props.params.productId : null;

    // Check retailer
    let retailer = Api.cache.getRetailer();
    if (retailer && retailer.token !== this.props.params.retailerToken) retailer = null;

    // Check category cache
    let categoryPayload = this.setupCategory(props);
    let browsePayload = Api.createProductBrowseNewPayload(categoryPayload.category, categoryPayload.subcategory, categoryPayload.filter);
    let browseCacheKey = Api.generateProductBrowseKey(browsePayload);
    let recommendationSet = Api.cache.getCategoryData(browseCacheKey);

    // Cache key for recent orders
    this.recentOrdersPayload = Api.createProductBrowseNewPayload(RECENT_ORDERS_CATEGORY);
    this.recentOrdersCacheKey = Api.generateProductBrowseKey(this.recentOrdersPayload);

    this.categoryRequestLock = null;
    this.searchRequestLock = null;
    this.state = Object.assign(
      {
        error: null,
        retailer: retailer,
        user: Api.cache.getUser(),
        activeRecommendationType: RECOMMENDATION_TYPES.CATEGORY,
        categorySearching: false,
        categories: Api.cache.getCategories(),
        categoryRecommendations: null,
        margins: {},
        isSearching: !!Api.cache.getProductSearchTerm(),
        productToken: productToken,
        searchVisible: Api.cache.getProductSearchActive(),
        searchTerm: Api.cache.getProductSearchTerm(),
        searchRecommendations: null,
        cartVisible: Api.cache.getCartVisible(),
        currentFilter: Api.cache.getCurrentRecommendationFilter(),
        recentOrders: Api.cache.getCategoryData(this.recentOrdersCacheKey),
        recommendations: recommendationSet
      },
      categoryPayload
    );

    Api.cache.setActiveCategory(categoryPayload);
  }

  selectProduct(product) {
    this.context.router.push(this.generateProductUrl(product));
  }

  selectCollection(collection) {
    this.context.router.push(this.generateCollectionUrl(collection));
  }

  generateProductUrl(product) {
    let url = `/retailer/${this.props.params.retailerToken}`;
    if (this.props.params.categoryName) url += `/category/${this.props.params.categoryName}`;
    url += `/product/${product.token}`;
    return url;
  }

  generateCollectionUrl(collection) {
    return `/retailer/${this.props.params.retailerToken}/collection/${collection.token}`;
  }

  selectBrand(brand) {
    const url = `/retailer/${this.props.params.retailerToken}/brand/${brand.token}`;
    this.context.router.push(url);
  }

  componentWillMount() {
    Api.cache.setCurrentRecommendationSet(this.state.recommendations);
    Api.startListen(this, 'categories', Api.cache.eventTypes.CATEGORIES_CHANGED);
    Api.startListen(this, 'searchVisible', Api.cache.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED);
    Api.startListen(this, 'searchTerm', Api.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
    Api.startListen(this, 'cartVisible', Api.cache.eventTypes.CART_VISIBLE_CHANGED);
    Api.startListen(this, 'currentFilter', Api.cache.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED);
    Api.startListen(this, 'recommendations', Api.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
    Api.cache.addChangeListener(this.onRecentOrdersChanged, Api.cache.eventTypes.CATEGORY_DATA_CHANGED);
    Api.cache.addChangeListener(this.onUserChanged, Api.cache.eventTypes.USER_CHANGED);

    this.load(this.props.params.retailerToken);
  }

  componentDidMount() {
    if (lastRetailerScrollPosition > 0) {
      document.body.scrollTop = lastRetailerScrollPosition;
    }

    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    Api.stopListen(this, Api.cache.eventTypes.CATEGORIES_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.RECOMMENDATIONS_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.CART_VISIBLE_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
    Api.cache.removeChangeListener(this.onRecentOrdersChanged, Api.cache.eventTypes.CATEGORY_DATA_CHANGED);
    Api.cache.removeChangeListener(this.onUserChanged, Api.cache.eventTypes.USER_CHANGED);
    window.removeEventListener('scroll', this.onScroll);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.productToken !== nextProps.params.productId) {
      this.setState({
        productToken: nextProps.params.productId
      });
    }

    if (this.props.params.categoryName !== nextProps.params.categoryName) {
      this.setState(this.setupCategory(nextProps));
    }
  }

  componentDidUpdate(oldProps, oldState) {
    if (this.props.params.retailerToken !== oldProps.params.retailerToken) {
      // If our retailer ever changes, load the new one.
      const loaded = this.load(this.props.params.retailerToken);
      if (loaded) return;

      if (this.props.params.categoryName !== oldProps.params.categoryName) {
        this.loadCategoryProducts();
      }
    }

    let shouldUpdate = false;
    // Simple search term changed. Search bar is visible
    shouldUpdate = shouldUpdate
      || (oldState.searchTerm !== this.state.searchTerm && this.state.searchVisible);

    // Search bar is no longer visible
    shouldUpdate = shouldUpdate
      || (!this.state.searchVisible && oldState.searchVisible);

    // Search bar is now visible and it already has a searchTerm
    shouldUpdate = shouldUpdate
      || (this.state.searchVisible && !oldState.searchVisible && this.state.searchTerm.trim().length > 0);

    // Category/Subcategory/Filter is changed
    shouldUpdate = shouldUpdate || (oldState.category !== this.state.category
      || oldState.subcategory !== this.state.subcategory
      || (oldState.filter && oldState.filter.value) !== (this.state.filter && this.state.filter.value));

    if (shouldUpdate) this.updateRecommendations();

    if (this.state.productToken) {
      document.body.classList.add('noscroll');
    } else {
      document.body.classList.remove('noscroll');
    }
  }

  onRecentOrdersChanged() {
    const recentOrders = Api.cache.getCategoryData(this.recentOrdersCacheKey);

    // check reference for the same object
    if (recentOrders !== this.state.recentOrders) {
      this.setState({
        recentOrders
      });
    }
  }

  onScroll() {
    const document = window.document;
    lastRetailerScrollPosition = document.body.scrollTop;

    // Only check to load more if category recommendations is active
    // and there is more to load
    if (this.state.activeRecommendationType !== RECOMMENDATION_TYPES.CATEGORY
      || !this.state.categoryRecommendations
      || !this.state.categoryRecommendations.loadMore) {
      return;
    }

    const documentHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );

    const windowPos = window.pageYOffset || document.documentElement.scrollTop;
    if (windowPos + window.innerHeight > (documentHeight - OFFSET_TO_LOAD)) {
      this.state.categoryRecommendations.loadMore();
    }
  }

  onUserChanged() {
    let newUser = Api.cache.getUser();
    if (newUser.token !== (this.state.user && this.state.user.token)) {
      Api.cache.setProductSearchRecommendations(null);
      Api.cache.setCategories(null);
      Api.cache.clearCategoryData();
      this.setState({
        user: newUser
      });
    }
  }

  getRecommendedProduct(productToken) {
    let recommendedProduct = null;

    if (this.state.recommendations && this.state.recommendations.products) {
      recommendedProduct = this.state.recommendations.products[productToken];
    }

    if (recommendedProduct) {
      return Promise.resolve(recommendedProduct);
    }

    return Api.getProduct(productToken, true)
      .then(productResponse => productResponse.products[productToken]);
  }

  load(retailerToken) {
    Api.getCategories();

    Api.getRetailer(retailerToken, true)
      .then(retailer => {
        this.setState({retailer});
        this.updateRecommendations();
      })
      .catch(this.handleLoadError);

    Api.getUser()
      .then(user => {
        this.setState({user});
      })
      .catch(this.handleLoadError);
  }

  handleLoadError(error) {
    if (error.httpStatusCode === 401) {
      const user = Api.cache.getUser();
      if (user && user.retailer_token && user.retailer_token !== this.props.params.retailerToken) {
        // Send the user to the Retailer they actually own.
        this.context.router.push(`/retailer/${user.retailer_token}`);
      } else if (!user) {
        // Handle user not loaded
        return Api.getUser()
          .then(user => {
            if (!user) {
              this.context.router.push('/user');
              return;
            }

            if (!user.retailer_token) {
              this.context.router.push('/');
              return;
            }
            this.context.router.push(`/retailer/${user.retailer_token}`);
          })
          .catch(() => this.context.router.push('/user'));
      } else {
        // Should never happen
        this.context.router.push('/');
      }
    } else {
      console.error(error);
      this.setState({error});
    }
  }

  updateRecommendations(requestId) {
    if (this.state.searchVisible && this.state.searchTerm && this.state.searchTerm.trim().length > 0) {
      this.loadSearchProducts(requestId);
    } else if (this.state.category || this.state.filter) {
      this.loadCategoryProducts(requestId);
    }
  }

  loadSearchProducts(requestId) {
    const requestLock = requestId || generateUUID();

    Api.cache.setCurrentRecommendationSet(null);
    this.setState({
      activeRecommendationType: RECOMMENDATION_TYPES.SEARCH,
      isSearching: true,
      categorySearching: false,
      searchRecommendations: null
    }, () => {
      if (this.searchRequestLock === requestLock) return null;
      this.searchRequestLock = requestLock;
      Api.productBrowseNew({query: this.state.searchTerm})
        .then(recommendations => {
            Api.cache.setCurrentRecommendationSet(recommendations);
            this.setState({
              isSearching: false,
              searchRecommendations: recommendations
            });
          }
        );
    });
  }

  loadCategoryProducts(requestId) {
    // Set the current recommendation set to whatever we have in cache, if anything.
    let request = Api.createProductBrowseNewPayload(this.state.category, this.state.subcategory, this.state.filter);
    let browseCacheKey = Api.generateProductBrowseKey(request);
    let recommendationSet = Api.cache.getCategoryData(browseCacheKey);
    Api.cache.setCurrentRecommendationSet(recommendationSet);

    this.setState({
      activeRecommendationType: RECOMMENDATION_TYPES.CATEGORY,
      isSearching: false,
      categorySearching: !recommendationSet,
      categoryRecommendations: null
    }, () => {
      const requestUUID = requestId || generateUUID();
      const activeCategoryPromise = this.loadContinuous(request, requestUUID, this.state.category);

      const promises = this.state.category === JUST_FOR_YOU_CATEGORY
        ? [activeCategoryPromise, Api.productBrowseNew(this.recentOrdersPayload, true)]
        : [activeCategoryPromise];

      Promise.all(promises)
        .then(() => {
          this.setState({
            categorySearching: false,
            isSearching: false
          })
        });
    });
  }

  // Note: skipCache can only be set to true for non-paginated categories!
  loadContinuous(request, requestId, skipCache) {
    if (this.categoryRequestLock === requestId) return null;
    this.categoryRequestLock = requestId;

    return Api.productBrowseNew(request, skipCache)
      .then(response => {
        if (this.categoryRequestLock !== requestId) return;

        let recommendations = response;

        if (response.next_request) {
          let nextRequestId = response.next_request.pagination_token;
          recommendations.loadMore = this.loadContinuous.bind(this, response.next_request, nextRequestId);
        } else {
          this.categoryRequestLock = null;
          recommendations.loadMore = null;
        }

        Api.cache.setCurrentRecommendationSet(recommendations);
        this.setState({
          categoryRecommendations: recommendations
        });
      });
  }


  getMargin(token) {
    let margins = this.state.margins;
    if (Object.keys(margins).indexOf(token) < 0) return 0;
    return margins[token];
  }

  setCategory(category, subcategory, filter) {
    let categoryTuple = '';
    let location = `/retailer/${this.props.params.retailerToken}`;
    if (category && category !== JUST_FOR_YOU_CATEGORY) {
      categoryTuple = category;
      if (subcategory) categoryTuple += `+${subcategory}`;
    }

    if (filter) categoryTuple += `:${filter.name}`;

    if (categoryTuple) {
      location += `/category/${categoryTuple}`;
    }

    this.context.router.push(location);
    Api.cache.setActiveCategory({category, subcategory, filter});

    Api.cache.setProductSearchActive(false);
  }

  setupCategory(props) {
    props = props || this.props;
    if (!props || !props.params || !props.params.categoryName) {
      return {
        category: JUST_FOR_YOU_CATEGORY,
        subcategory: null,
        filter: null
      };
    }

    let categoryName, subcategoryName, filterName;
    let filter = null;
    let categoryString = props.params.categoryName;

    let aux = categoryString.split(':');

    if (aux.length === 0) {
      categoryName = JUST_FOR_YOU_CATEGORY;
      subcategoryName = null;
      filterName = null;
    } else if (aux.length === 1 || aux.length === 2) {
      let aux2 = aux[0].split('+');
      categoryName = aux2[0] || JUST_FOR_YOU_CATEGORY;
      subcategoryName = aux2[1];
      filterName = aux[1];
    } else {
      return null;
    }

    if (filterName) filter = CATEGORY_FILTERS.find(categoryFilter => categoryFilter.name === filterName);

    return {
      category: categoryName,
      subcategory: subcategoryName,
      filter: filter
    };
  }

  categoryBar() {
    if (!this.state.categories) return null;
    return <CategoryBar categories={this.state.categories}
                        filters={CATEGORY_FILTERS}
                        activeCategory={this.state.category}
                        activeSubcategory={this.state.subcategory}
                        activeFilter={this.state.filter}
                        onSelect={this.setCategory}/>
  }

  closeProductModal() {
    this.redirectToRetailerPage(true);
  }

  getCartSelection() {
    let cartSelection = null;
    let cart = Api.cache.getCart();
    if (cart && cart.cart && cart.cart.items && cart.cart.items.length > 0) {
      let productOptionsInCart = cart.cart.items.filter(cartItem => {
        return cartItem.product_token === this.state.productToken;
      });

      if (productOptionsInCart.length > 0) {
        let product = cart.products[productOptionsInCart[0].product_token];
        let batchCount = product.options[0].unit_multiplier;
        cartSelection = productOptionsInCart.map(cartItem => {
          return {
            option: cartItem.product_option_token,
            batches: cartItem.quantity / batchCount
          };
        });
      }
    }

    return cartSelection;
  }

  productModal() {
    if (this.state.productToken) {
      document.body.classList.add('noscroll');
    } else {
      document.body.classList.remove('noscroll');
    }

    let urlPrefix = `/retailer/${this.props.params.retailerToken}`;
    if (this.props.params.categoryName) urlPrefix += `/category/${this.props.params.categoryName}`;

    let cartSelection = this.getCartSelection();

    return (
      <LightBox onClose={this.closeProductModal} className={this.state.productToken ? '' : 'hidden'}>
        <RetailerProduct
          urlPrefix={urlPrefix}
          productToken={this.state.productToken}
          retailerToken={this.props.params.retailerToken}
          onSave={this.addToCart}
          defaultSelection={cartSelection}
          buttonText={!cartSelection ? calculateButtonText : 'Save'}
          isEmployee={this.state.user && this.state.user.is_employee}
        />
      </LightBox>
    );
  }

  redirectToRetailerPage(replace) {
    replace = replace || false;
    let url = `/retailer/${this.props.params.retailerToken}`;
    if (this.props.params.categoryName) url += `/category/${this.props.params.categoryName}`;

    if (!replace) {
      this.context.router.push(url);
    } else {
      let previousObject = (historyList.previous() || {});
      let previous = (previousObject.pathname || '').replace(/%20/g, ' ');
      if (previous === url) {
        this.context.router.goBack();
      } else {
        this.context.router.replace(url);
      }
    }
  }

  addToCart(productToken, productOptions) {
    let cartItems = null;

    return this.getRecommendedProduct(productToken)
      .then(product => {
        if (!product) {
          console.error('Cannot find product with token %s', productToken);
          return null;
        }

        cartItems = productOptions.map(selection => {
          let selectedOption = product.options.find((option) => selection.option === option.token);
          let bagEntry = {};
          bagEntry.brand_token = product.brand_token;
          bagEntry.product_token = product.token;
          bagEntry.product_option_token = selectedOption.token;
          bagEntry.quantity = selection.batches * selectedOption.unit_multiplier;
          bagEntry.price_cents = selectedOption.wholesale_price_cents;

          return bagEntry;
        });
      })
      .then(() => {
        let oldSelection = this.getCartSelection();
        // Delete existing items from cart before continuing
        if (oldSelection && oldSelection.length > 0) {
          return Api.removeFromCart(oldSelection.map(selection => selection.option));
        }
      })
      .then(() => Api.addToCart(cartItems))
      .then(result => {
        this.redirectToRetailerPage(true);
        return result;
      })
      .catch(error => {
        console.error(error);
      });
  }

  isActiveJustForYou() {
    return this.state.activeRecommendationType === RECOMMENDATION_TYPES.CATEGORY
      && this.state.category === JUST_FOR_YOU_CATEGORY;
  }

  render() {
    if (!this.state.retailer) {
      return (
        <div>
          <div className="retailer-loading-wrapper">
            <Processing />
          </div>
        </div>
      );
    }

    const retailerInvited = this.state.retailer && this.state.retailer.invited;
    const isEmployee = this.state.user && this.state.user.is_employee;
    const forceLead = this.props.location && this.props.location.query && this.props.location.query.lead === "1";

    if (forceLead || (!retailerInvited && !isEmployee)) {
      return <NoProducts retailer={this.state.retailer}/>;
    }

    const activeRecommendations = this.state.recommendations;
    if (this.state.isSearching
      || this.state.categorySearching
      || !this.state.categories
      || !activeRecommendations
      || (this.isActiveJustForYou() && !this.state.recentOrders)
      || !this.state.retailer) {
      return (
        <div>
          {this.categoryBar()}
          <div className="retailer-loading-wrapper">
            <Processing />
          </div>
        </div>
      );
    }

    if (this.state.error) {
      return (
        <div className="error">
          {this.state.error.message}
        </div>
      );
    }

    let recommendations = null;
    if (activeRecommendations) {
      let displayOrder = activeRecommendations.display_order.reduce((displayOrder, token) => {
        if (displayOrder.indexOf(token) < 0) displayOrder.push(token);
        return displayOrder;
      }, []);

      let productMap = activeRecommendations.products;

      let isEmployee = this.state.user && this.state.user.is_employee;

      if (isEmployee && this.state.currentFilter.length > 0) {
        displayOrder = displayOrder.filter(productToken => {
          let product = productMap[productToken];
          let enabled = false;

          if (product) {
            if (this.state.currentFilter.length === 1 && this.state.currentFilter[0] === '+ACTIVE') {
              enabled = product.active;
            } else {
              this.state.currentFilter.forEach(filterValue => {
                if (product.recommenders && product.recommenders.indexOf(filterValue) >= 0) enabled = true;
              });
              if (enabled && this.state.currentFilter.indexOf('+ACTIVE') >= 0 && !product.active) enabled = false;
            }
          }

          return enabled;
        });
      }

      if (displayOrder.length === 0) {
        if (this.props.location.query.campaign === "1") return <LeadSubmittedMessage retailer={this.state.retailer}/>;

        let clearFilters = this.state.filter ?
          <div>
            <p>Clear filters above to view all results.</p>
            <p className="clear-filters"
               onClick={() => {
                 this.setCategory(this.state.category, this.state.subcategory, null)
               }}>
              Clear Filters
            </p>
          </div> : null;

        // Only show custom recommendations error view if no subcategory and filter are shown.
        const emptyView = (this.isActiveJustForYou() && this.state.filter === null && this.state.subcategory === null)
          ? <div>
            <h1>No Products</h1>
            <p>Email us at <a href="mailto:contact@indigofair.com">contact@indigofair.com</a> to get your custom
              recommendations!</p>
          </div>
          : <div>
            <h1>No Items Found</h1>
            <p>Try widening your search to see what's available.</p>
            {clearFilters}
          </div>;

        recommendations =
          <div className="no-results">
            {emptyView}
          </div>;
      } else if (this.isActiveJustForYou()) {
        recommendations = <div>
          <MakerRecommendationsList brands={activeRecommendations.brands}
                                    products={activeRecommendations.products}
                                    retailerToken={this.props.params.retailerToken}
                                    selectProduct={this.selectProduct}
                                    selectBrand={this.selectBrand}
                                    generateProductUrl={this.generateProductUrl}
          />
        </div>
      } else {
        let loading = activeRecommendations.loadMore ? <Processing /> : null;
        recommendations =
          <div>
            <RecommendationGrid
              products={productMap}
              brands={activeRecommendations.brands}
              collections={activeRecommendations.collections || {}}
              display_order={displayOrder}
              retailerToken={this.props.params.retailerToken}
              selectProduct={this.selectProduct}
              generateProductUrl={this.generateProductUrl}
              selectCollection={this.selectCollection}
              generateCollectionUrl={this.generateCollectionUrl}
            />
            {loading}
          </div>
      }
    }

    let classNames = ['retailer'];

    let headerTitle = (this.state.retailer && this.state.retailer.short_description) || JUST_FOR_YOU_CATEGORY;
    if (this.state.searchTerm) {
      headerTitle = 'Search: ' + this.state.searchTerm;
    } else if (this.state.subcategory) {
      headerTitle = capitalizeEveryWord(this.state.subcategory);
    } else if (this.state.category) {
      headerTitle = capitalizeEveryWord(this.state.category);
    }

    let reorderCarousel = null;
    if (this.isActiveJustForYou()) {
      reorderCarousel = <div className="buy-it-again">
        <RecentOrdersCarousel selectProduct={this.selectProduct}
                              recentOrders={this.state.recentOrders}
                              retailerToken={this.props.params.retailerToken}
                              selectBrand={this.selectBrand}
                              selectCollection={this.selectCollection}
                              generateProductUrl={this.generateProductUrl}>
          <div className="title">
            <Link to={`/retailer/${this.props.params.retailerToken}/category/${RECENT_ORDERS_CATEGORY}`}>
              <span>Buy it Again</span>
              <span>See all</span>
            </Link>
          </div>
        </RecentOrdersCarousel>
      </div>
    }

    const hideBreadCrumb = this.state.activeRecommendationType === RECOMMENDATION_TYPES.SEARCH
      || this.isActiveJustForYou();

    const footer = this.isActiveJustForYou()
      ? <Footer>Can't find a maker or items you love? <em><Link to="/brand-suggestion">Let us know!</Link></em></Footer>
      : null;

    return (
      <div className={classNames.join(' ')}>
        {this.categoryBar()}
        <div className="recommendation-wrapper">
          {reorderCarousel}
          <BreadCrumb primary={this.state.category}
                      secondary={this.state.subcategory}
                      className={ hideBreadCrumb ? "hide" : ""}
                      filter={this.state.category === SHOP_ALL_CATEGORY ? null : this.state.filter}
                      onSelect={(selection) => {
                        if (!selection) {
                          this.setCategory(null, null, this.state.filter);
                        } else if (selection === this.state.category) {
                          this.setCategory(this.state.category, null, this.state.filter);
                        }
                      }}
                      onClearFilters={() => {
                        this.setCategory(this.state.category, this.state.subcategory, null)
                      }}
                      onShopFilters={(filter) => {
                        this.setCategory(SHOP_ALL_CATEGORY, null, filter);
                      }}>
            <div className="recommendations-title">{headerTitle}</div>
          </BreadCrumb>
          {recommendations}
        </div>
        {this.productModal()}
        {footer}
      </div>
    );
  }
}

class LeadSubmittedMessage extends React.Component {
  static propTypes = {
    retailer: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.sendLead = this.sendLead.bind(this);
  }

  componentDidMount() {
    this.sendLead();
  }

  sendLead() {
    let payload = {
      first_name: '',
      last_name: '',
      email_address: 'campaign@indigofair.com',
      phone_number: '',
      note: `Campaign lead for '${this.props.retailer.name}' (${this.props.retailer.token})`
    };

    Api.retailerLead(this.props.retailer.token, payload);
  }

  render() {
    return (
      <div className="no-products">
        <h2>Thank you!</h2>
        <p>Your request has been received. We will email you a link to view the Indigo Fair product catalogue within
          24 hours</p>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Retailer.js
 **/